import { Link, router, usePage } from "@inertiajs/react"
import { Building2, CalendarClock, FileText, FolderUp, Layers, LayoutDashboard, LogOut, Shield, Users } from "lucide-react"
import { Button } from "../ui/button"
import type { SharedPageProps } from "../../types/shared"

const menuItems = [
  {
    title: "Dashboard",
    href: "/",
    icon: LayoutDashboard
  },
  {
    title: "Clientes",
    href: "/clientes",
    icon: Users
  },
  {
    title: "Empresas",
    href: "/empresas",
    icon: Building2
  },
  {
    title: "Usuários",
    href: "/usuarios",
    icon: Shield
  },
  {
    title: "Datas de Pagamento",
    href: "/datas-pagamento",
    icon: CalendarClock
  },
  {
    title: "Notas Fiscais",
    href: "/notas-fiscais",
    icon: FileText
  },
  {
    title: "Emissão em Massa",
    href: "/notas-fiscais/emissao-em-massa",
    icon: Layers
  },
  {
    title: "Importação NFSe",
    href: "/notas-fiscais/importacao",
    icon: FolderUp
  }
]

export function AppSidebar() {
  const { props, url } = usePage<SharedPageProps>()
  const userEmail = props.auth.user?.email ?? "Usuário"

  return (
    <aside className="flex min-h-screen w-64 flex-col border-r border-slate-800 bg-slate-900">
      <div className="flex h-16 items-center gap-2 border-b border-slate-800 px-5">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-600">
          <span className="text-sm font-bold text-white">PT</span>
        </div>
        <span className="text-base font-semibold text-slate-100">Portal TUV</span>
      </div>

      <nav className="flex-1 space-y-1 p-4">
        {menuItems.map((item) => {
          const Icon = item.icon
          const active = url === item.href || url.startsWith(`${item.href}/`)

          return (
            <Link
              key={item.href}
              href={item.href}
              className={[
                "flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors",
                active ? "bg-slate-800 text-white" : "text-slate-300 hover:bg-slate-800/70 hover:text-white"
              ].join(" ")}
            >
              <Icon className="h-4 w-4" />
              <span>{item.title}</span>
            </Link>
          )
        })}
      </nav>

      <div className="border-t border-slate-800 p-4">
        <p className="mb-3 truncate text-xs text-slate-400">{userEmail}</p>
        <Button
          variant="outline"
          className="w-full border-slate-700 bg-slate-900 text-slate-100 hover:bg-slate-800"
          onClick={() => router.delete("/users/sign_out")}
        >
          <LogOut className="mr-2 h-4 w-4" />
          Sair
        </Button>
      </div>
    </aside>
  )
}
